import {ApiService, ApiServiceContext} from '@app/services/api.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Methodology} from '@app/models/methodology.model';
import {catchError} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class MethodologyService extends ApiService {

  // /people-search-methodology-types

  constructor(ctx: ApiServiceContext) {
    super(ctx);
  }

  getAllPeopleMethodology(): Observable<Methodology[]> {
    return this.http.get<Methodology[]>('/api/people-search-methodology-types').pipe(catchError(this.handleError));
  }

  getAllMethodologyTypes(): Observable<Methodology[]> {
    return this.http.get<Methodology[]>('/api/methodology-types').pipe(catchError(this.handleError));
  }
}
